import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppBanner.css";
import { siteData } from "../../data/siteData";

function WhatsAppBanner() {
  return (
    <section
      className="whatsapp-banner-section"
      data-aos="zoom-in-up"
      data-aos-duration="1000"
    >
      <div className="container">
        <div className="whatsapp-banner">
          <div className="whatsapp-icon-wrapper">
            <FaWhatsapp />
          </div>

          <span className="whatsapp-badge">Quick Support Available</span>

          <h2>Need Immediate Assistance?</h2>

          <p>
            Chat directly with our technician on WhatsApp and get instant
            guidance for your mobile repair issue.
          </p>

          <a
            href={`https://wa.me/${siteData.whatsapp.replace("+", "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn whatsapp-banner-btn"
          >
            <FaWhatsapp />

            <span>Start WhatsApp Chat</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default WhatsAppBanner;
